export enum ApiEnumConfigurations {
  CalendarMonths = "CalendarMonths",
  CherryPayCardOrderStatus = "CherryPayCardOrderStatus",
  Timezone = "Timezone",
}
